module.exports = __webpack_public_path__ + "img/activityBg.0aafdd9.png";